import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { recordLedgerAdjustment, ILedgerAdjustmentResponse } from "./ledgerAdjustmentThunk";

interface ILedgerAdjustmentState {
    loading: boolean;
    error: string | null;
    lastResult: ILedgerAdjustmentResponse | null;
}

const initialState: ILedgerAdjustmentState = {
    loading: false,
    error: null,
    lastResult: null,
};

const ledgerAdjustmentSlice = createSlice({
    name: "ledgerAdjustment",
    initialState,
    reducers: {
        resetAdjustmentState: (state) => {
            state.loading = false;
            state.error = null;
            state.lastResult = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(recordLedgerAdjustment.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(recordLedgerAdjustment.fulfilled, (state, action: PayloadAction<ILedgerAdjustmentResponse>) => {
                state.loading = false;
                state.lastResult = action.payload;
                state.error = null;
            })
            .addCase(recordLedgerAdjustment.rejected, (state, action: any) => {
                state.loading = false;
                state.error = action.payload || "An error occurred";
            });
    },
});

export const { resetAdjustmentState } = ledgerAdjustmentSlice.actions;
export default ledgerAdjustmentSlice.reducer;
